module.exports = __webpack_public_path__ + "img/1585.cea59a1a.png";